module.exports = __webpack_public_path__ + "static/hyperv_21.9c981105.jpg";